module.exports = __webpack_public_path__ + "static/media/ultimo_chilometro.912d9d1e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/ultimo_chilometro.mp3
// module id = 191
// module chunks = 0